import { layoutNameIsValid } from './layout-name-is-valid.esm.js';
import { trim } from './trim.esm.js';

var normalizeLayoutName = function normalizeLayoutName(input) {
  if (!layoutNameIsValid(input)) {
    return '';
  }
  return trim(input) || '';
};

export { normalizeLayoutName };
//# sourceMappingURL=normalize-layout-name.esm.js.map
